import { CATEGORIES, type Category } from './constants'

interface Props {
  value: Category
  onChange: (c: Category) => void
}

export default function CategoryPicker({ value, onChange }: Props) {
  return (
    <div className="category-picker">
      {CATEGORIES.map(cat => (
        <button
          key={cat}
          type="button"
          className={`cat-btn${value === cat ? ' active' : ''}`}
          onClick={() => onChange(cat)}
        >
          {cat}
        </button>
      ))}
    </div>
  )
}
